import { conferenceTypesEnum } from "../components/ConferenceType/conferenceTypesEnum"

export const valid = ({state}) => {
    if(state.conference_type === conferenceTypesEnum.group && !state?.groups?.length) {
        return {
            value: false,
            text: 'не выбрана ни одна группа'
        }
    }
    if(state.conference_type === conferenceTypesEnum.private && !state?.childrens?.length) {
        return {
            value: false,
            text: 'не выбран ученик'
        }
    }
    
    return {
            value: true,
            text: ''
    }
}